import './CheckboxFilter.css';
import CheckboxSelector from "./sub/CheckboxSelector/CheckboxSelector.jsx";

export default function CheckboxFilter({array,label,filters,setFilters}) {
    return <>
        <span className='checkbox-filter-label-1'>{label}</span>
        {
            array.map((element, index) => {
                return <CheckboxSelector label={element} key={index} parentLabel={label}
                filters={filters} setFilters={setFilters}/>;
            })
        }
    </>;
}
